var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.8934 25.2248H31.4496C32.3091 25.2248 33.0058 24.5281 33.0058 23.6686V6.55037C33.0058 5.69091 32.3091 4.99417 31.4496 4.99417H14.3314C13.4719 4.99417 12.7751 5.69091 12.7751 6.55037V8.10658",
    stroke: "#0074B2",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7752 12.7752H6.55034C5.69088 12.7752 4.99414 13.4719 4.99414 14.3314V31.4496C4.99414 32.3091 5.69088 33.0058 6.55034 33.0058H23.6686C24.5281 33.0058 25.2248 32.3091 25.2248 31.4496V25.2248H14.3314C13.4719 25.2248 12.7752 24.5281 12.7752 23.6686V12.7752Z",
    stroke: "#0074B2",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.6aebd1e3e397a1d4ee60a85e29ee934a.svg";
export { ForwardRef as ReactComponent };